import Prescriptions from "./Prescriptions";
export default Prescriptions;
